/* eslint-disable @typescript-eslint/camelcase */
// @flow
import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader/root'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import LineMap from '../lineMap'
import BarChart from '../barChartLines'
import BarChartComp from '../barChartComp'
import BarChartRank from '../barChartRank'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import * as d3 from 'd3'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { Tracking } from '../contentbricks'

const data = require('../mietmaps_d3 - bars_bern.csv')
const isEdge = window.navigator.userAgent.indexOf('Edge') !== -1
const isIE = window.navigator.userAgent.indexOf('Trident') !== -1 && !isEdge

var sortedData = {}
var missing = {}
data.forEach(d => {
  if (!sortedData['L' + d.linie]) sortedData['L' + d.linie] = []
  if (!missing['L' + d.linie]) missing['L' + d.linie] = []

  if (d.Mietpreis !== '') {
    sortedData['L' + d.linie].push(d)
  } else {
    missing['L' + d.linie].push(d.Haltestelle)
  }
})
var minMax = d3.extent(data, d => {
  return +d.Mietpreis
})

console.log(sortedData)
// TODO Set the correct article ID here
const ARTICLE_ID = '19904095'
const lines = {
  L6: {
    number: 6,
    color: '#fff',
    background: '#009ee3',
    route: 'Fischermätteli – Worb Dorf',
    notes: ''
  },
  L7: {
    number: 7,
    color: '#fff',
    background: '#e3000b',
    route: 'Bümpliz – Ostring',
    notes: ''
  },
  L8: {
    number: 8,
    color: '#fff',
    background: '#e82d89',
    route: 'Brünnen Westside – Saali',
    notes: 'Technopark: Keine Angaben'
  },
  L9: {
    number: 9,
    color: '#000',
    background: '#ffd400',
    route: 'Wabern - Wankdorf Bhf',
    notes: ''
  }
}
function AppComponent() {
  var w = window
  var d = document
  var e = d.documentElement
  var g = d.getElementsByTagName('body')[0]
  var x = w.innerWidth || e.clientWidth || g.clientWidth

  const widthReduce = 0.8
  const [currentLine, setLine] = useState(6)
  const currentData = lines['L' + currentLine]

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} additionalShares={40} />
      <ThemeSwitch />

      {/* TODO Replace the following segment with your project cover */}
      <header className='ui vertical  segment'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
              Entlang welcher Tramlinien die Mieten am höchsten sind
              <div className='sub header'>
                Die gleiche Wohnung kostet je nach Lage bis zu{' '}
                <span className='nobreak'>1200 Franken</span> mehr im Monat.
                Suchen Sie die Haltestelle in Ihrer Nähe.
              </div>
            </div>
          </h1>
          <p className='ta author'>
            Von Yannick Wiget, Dino Caracciolo und Sebastian Broschinski
          </p>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          Wer eine neue Wohnung sucht, berücksichtigt verschiedene Faktoren. Am
          wichtigsten ist wohl der Mietpreis. Aber auch andere Kriterien wie
          Grösse, Zustand, Lage und Lärmsituation spielen eine Rolle. Immer
          wichtiger wird zudem die Anbindung an den öffentlichen Verkehr. Gerade
          in Städten ist es nicht einfach, eine Wohnung in unmittelbarer Nähe
          zum Arbeitsplatz zu finden.
          <br />
          <br /> Das Immobilienportal Homegate hat deshalb ausgerechnet, wie
          sich die Mietpreise entlang des Berner Tramnetzes entwickeln. Die
          Auswertung zeigt, dass eine gleich grosse Wohnung je nach Haltestelle
          fast <span className='nobreak'>1200 Franken</span> mehr kosten kann.
        </div>
      </div>
      <div className='ui text container datasource'>
        <div className='ui vertical segment soureceContainer'>
          Die Preise beziehen sich auf die Bruttomiete (inkl. Nebenkosten) einer{' '}
          <span className='nobreak'>3-Zimmer-Wohnung</span> mit etwa{' '}
          <span className='nobreak'>70 Quadratmetern</span>. Homegate hat sich
          alle entsprechenden Inserate angeschaut, die im Zeitraum von Januar
          2018 bis Mai 2019 auf seiner Plattform publiziert wurden. Anhand der
          fünfzig Wohnungen, die am nächsten bei der jeweiligen Haltestelle
          lagen, wurde ein Durchschnittspreis ermittelt. Die{' '}
          <span className='nobreak'>Linie 3</span> von Weissenbühl zum
          Hauptbahnhof fehlt in der Auswertung.
        </div>
      </div>
      <div className='ui vertical segment bars'>
        <div className='ui  text container'>
          <div className='rankingsTitle'>
            Mietpreise in der Umgebung der Haltestellen{' '}
          </div>
          <div className='rankingsSub'>
            Durchschnittlicher Bruttomietpreis für eine 3-Zimmer-Wohnung, in
            Franken{' '}
          </div>
          <div className='ui vertical  raised segment menu'>
            <div className='menuHint'>
              <i className='arrow down icon' /> Wählen Sie eine Linie aus
            </div>
            <div className='menuContainer'>
              {Object.values(lines).map(line => {
                return (
                  <button
                    key={line.number}
                    onClick={() => {
                      window.dataLayer = window.dataLayer || []
                      window.dataLayer.push({
                        event: 'Interactions',
                        event_action: 'clickOrTap',
                        event_label: 'lineSelected'
                      })
                      setLine(line.number)
                    }}
                    className={
                      'lineNumber l' +
                      line.number +
                      ' ' +
                      (currentData.number === line.number ? 'active' : '')
                    }
                  >
                    {line.number}
                  </button>
                )
              })}
            </div>
          </div>
          <div
            className='lineTitleB'
            style={{
              backgroundColor: currentData.background,
              color: currentData.color
            }}
          >
            {currentData.number}
          </div>

          <div className='lineRoute'>{currentData.route}</div>
          <div className='rankingsSub'>
            {' '}
            Durchschnittlicher Mietpreis, in Franken{' '}
          </div>

          <svg id='barChart' width='100%' height='800px' />

          <BarChart
            line={currentData}
            data={sortedData['L' + currentLine]}
            minMax={minMax}
            maxWidth={x * widthReduce < 500 ? x * widthReduce : 500}
            svgID='barChart'
          />
          <Tracking label='content25' />

          {missing['L' + currentLine].length > 0 && (
            <div className='lineNotes'>
              Keine Daten für: {missing['L' + currentLine].join(', ')}
            </div>
          )}
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          Am deutlichsten zeigen sich die Preisunterschiede entlang der
          <span className='nobreak'>
            {' '}
            Linie <span className='lineInText l6'>6</span>,{' '}
          </span>
          die auf ihrem Weg durch die Stadt viele verschiedene Quartiere
          passiert. Sie fährt vom Fischermätteli via Mattenhof und Monbijou zum
          Hauptbahnhof, von dort durch die Altstadt, überquert nach dem
          Bundeshaus die Aare und gelangt via Muri bis nach Worb.
          <br />
          <br />
          Dort kostet eine Wohnung durchschnittlich nur noch{' '}
          <span className='nobreak'>1300 Franken</span> im Monat. In der Mitte
          der Strecke, im Umkreis der Haltestelle Bärenplatz, beläuft sich die
          Miete auf <span className='nobreak'>2480 Franken</span> – fast das
          Doppelte.
          <br />
          <br />
          Wesentlich geringer sind die Preisunterschiede auf der Strecke
          Wabern–Wankdorf, wo das{' '}
          <span className='nobreak'>
            {' '}
            Tram <span className='lineInText l9'>9</span>,{' '}
          </span>{' '}
          verkehrt. Zwischen der höchsten und der tiefsten Miete liegen nur{' '}
          <span className='nobreak'>960 Franken.</span>
        </div>
      </div>
      <div className='ui vertical segment lineMapContainer'>
        <div className='ui mobile only zoomHint'>
          <div className='zoomIcon'>
            <img src={require('images/spread.svg')} width='30px' />
          </div>
          <div className='zoomText'>
            Zoomen Sie in die Karte, um die Haltestelle in der Nähe Ihres
            Wohnortes zu finden.
          </div>
        </div>
        {!isIE ? (
          <LineMap />
        ) : (
          <img src={require('../../images/karte-tramlinien_bern.svg')} />
        )}
        <Tracking label='content50' />
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          Die Linie{' '}
          <span className='nobreak'>
            <span className='lineInText l9'>9</span>
          </span>{' '}
          ist denn auch die Strecke, an der man am meisten zahlt. Bei keiner
          Haltestelle liegt die Miete unter{' '}
          <span className='nobreak'>1500 Franken.</span> Im Schnitt blättert man{' '}
          <span className='nobreak'>1772 Franken</span> für eine{' '}
          <span className='nobreak'>3-Zimmer-Wohnung</span> hin. Auch die Linie{' '}
          <span className='lineInText l7'>7</span> knackt die
          1700-Franken-Marke.
          <br />
          <br />
          Vergleichsweise preiswert lebt man hingegen an den Linien{' '}
          <span className='lineInText l6'>6</span> und{' '}
          <span className='lineInText l8'>8</span> . Mit einer
          Durchschnittsmiete von <span className='nobreak'>1641 Franken</span>{' '}
          ist die Strecke Fischermätteli–Worb am günstigsten.
          <br />
          <div className='rankingsTitle'>
            Durchschnittspreise entlang der Linien
          </div>
          <div className='rankingsSub'>in Franken </div>
          <svg id='lineComp' width='100%' height='800px' />
          <BarChartComp
            lines={lines}
            data={sortedData.Ldurchschnitt}
            minMax={minMax}
            maxWidth={x * widthReduce < 500 ? x * widthReduce : 500}
            svgID='lineComp'
          />
        </div>
        <div className='ui text container'>
          Generell gilt: Je zentraler die Wohnung, desto höher die Mieten. Mit
          Abstand am teuersten sind sie am Bärenplatz: Stolze{' '}
          <span className='nobreak'>2480 Franken</span> legt man hier im Schnitt
          pro Monat auf den Tisch. Kostspielige Pflaster sind auch der
          Luisenplatz, der Helvetiaplatz, die Zytglogge und allgemein zentrale
          Wohnungen an der Aare.
          <br />
          <br />
          <div className='rankingsTitle'>
            {'An diesen Haltestellen sind die Mieten am höchsten'}
          </div>
          <div className='rankingsSub'>
            {' '}
            Durchschnittlicher Preis, in Franken{' '}
          </div>
          <svg id='lineTeuer' width='100%' height='800px' />
          <BarChartRank
            lines={lines}
            data={sortedData.Lteuerste}
            minMax={minMax}
            maxWidth={x * widthReduce < 500 ? x * widthReduce : 500}
            svgID='lineTeuer'
          />
        </div>
        <div className='ui text container'>
          Solche Preise sind aber die Ausnahme. Die meisten{' '}
          <span className='nobreak'>3-Zimmer-Wohnungen</span> gibt es in Bern
          für unter <span className='nobreak'>1800 Franken</span> im Monat. Am
          günstigsten wohnt man in östlichen Teilen der Stadt, etwa in Worb.
          Dafür muss bis zum Hauptbahnhof eine knappe halbe Stunde Fahrtzeit in
          Kauf genommen werden wie auch bei anderen preiswerten Stationen.
          <br />
          <div className='rankingsTitle'>
            An diesen Haltestellen sind die Mieten am tiefsten
          </div>
          <div className='rankingsSub'>
            Durchschnittlicher Preis, in Franken{' '}
          </div>
          <Tracking label='content75' />
          <svg id='lineBillig' width='100%' height='800px' />
          <BarChartRank
            lines={lines}
            data={sortedData.Lbilligste}
            minMax={minMax}
            maxWidth={x * widthReduce < 500 ? x * widthReduce : 500}
            svgID='lineBillig'
          />
        </div>
        <div className='ui text container'>
          Im Durchschnitt kostet eine Wohnung entlang der Berner Tramlinien{' '}
          <span className='nobreak'>1619 Franken.</span> Das ist ein bisschen
          mehr als in Basel <span className='nobreak'>(1602 Franken),</span>{' '}
          aber deutlich weniger als in Zürich{' '}
          <span className='nobreak'>(2347 Franken).</span> In allen drei Städten
          sind die Preise von{' '}
          <span className='nobreak'>3-Zimmer-Wohnungen</span> in den letzten
          Jahren mehrheitlich gestiegen. Und gerade in Quartieren, wo neue
          Projekte wie Dienstleistungsgebäude, Wohnsiedlungen und öffentliche
          Bauten entstehen, werden die Mieten künftig noch zunehmen.
          <br />
          <br />
          Grundsätzlich gilt, dass die Gesamtkosten für eine Wohnung maximal{' '}
          <span className='nobreak'>30 Prozent</span> des Nettoeinkommens
          ausmachen sollten. Viele Budgetberatungen empfehlen, höchstens ein
          Viertel des Lohns für die Miete auszugeben. Damit ist sichergestellt,
          dass die restlichen Kosten für die Lebenshaltung gedeckt werden
          können.
        </div>
      </div>

      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        questions={[
          '        Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Analyse und Text', 'Yannick Wiget'],
          [
            'Gestaltung und Umsetzung',
            'Dino Caracciolo und Sebastian Broschinski'
          ],
          ['Quelle', 'homegate.ch']
        ]}
      />
    </div>
  )
}

export default hot(AppComponent)
